import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { LedgersService } from 'src/app/share/services/ledgers/ledgers.service';
import { DefaultConfig } from 'src/app/share/configs/plotly.config';

@Component({
    selector: 'app-performance-closing-balance',
    templateUrl: './performance-closing-balance.component.html',
    styleUrls: ['./performance-closing-balance.component.scss'],
    standalone: false
})
export class PerformanceClosingBalanceComponent implements OnChanges {
  @Input() selectedTyre: any;
  @Input() selectedRange: any;

  loading: boolean = false;
  errorMessage: string = '';

  public graph: any = {
    data: [],
    layout: {},
    config: {}
  };

  tabledata: any[] = [];
  viewMode: 'chart' | 'table' = 'table';


  constructor(private readonly ledgersService: LedgersService) { }

  setViewMode(mode: 'chart' | 'table') {
    this.viewMode = mode;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedRange']?.currentValue) {
      if (this.selectedRange) {
        this.getData();
      }
    }
  }

  getData() {
    if (!this.selectedTyre) return;
    this.loading = true;
    this.errorMessage = '';
    const payload = {
      tyreSize: this.selectedTyre.tyreSize,
      tyreMake: this.selectedTyre.tyreMake,
      tyreModel: this.selectedTyre.tyreModel,
      created_datefrom: this.selectedRange.startDate,
      created_dateupto: this.selectedRange.endDate,
    };

    this.ledgersService.getClosingBalanceByBranch(payload).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res?.data) {
          this.mapApiData(res.data);
          this.mapTabledata(res.data);
        } else {
          this.errorMessage = 'No data found';
        }
      },
      error: (error: any) => {
        this.loading = false;
        this.errorMessage = error?.error?.message || "Failed to fetch closing balance";
      }
    });
  }

  mapTabledata(data: any[]) {
    this.tabledata = data.map((item) => {
      return {
        company: item.companyName,
        closingBalance: item.totalQuantity,
        closingValue: item.closingValue,
        avgPrice: item.avgPrice,
        lastMoment: item.lastSaleDate
          ? new Date(item.lastSaleDate).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            timeZone: 'Asia/Kolkata'
          })
          : '',
      }
    })
  }

  mapApiData(apiData: any[]) {
    const labels = apiData.map(item => item.companyName || 0) || [];
    const values = apiData.map(item => item.totalQuantity || 0) || [];
    this.initGraph({ closingBalance: values, companies: labels });
  }

  initGraph(apiData: any) {
    // apiData structure: { closingBalance: number[], companies: string[] }
    const labels = (apiData.companies || []).map((label: string, index: number) => {
      return label + '\u200b'.repeat(index);
    });
    const values = apiData.closingBalance || [];
    const maxAbsValue = values.length > 0 ? Math.max(...values.map((v: any) => Math.abs(v))) : 0;

    this.graph.data = [
      {
        x: labels,
        y: values,
        type: 'bar',
        marker: {
          color: '#00305C',
          cornerradius: 12
        },
        hovertemplate: '<b>%{x}</b><br>Closing Balance: %{y}<extra></extra>',
      }
    ];

    let gap = 0.25;
    if (labels.length <= 1) {
      gap = 0.85;
    } else if (labels.length <= 3) {
      gap = 0.65;
    }

    this.graph.layout = {
      autosize: true,
      xaxis: {
        type: 'category',
        showgrid: false,
        zeroline: false,
        tickfont: { color: '#00305C', size: 10, family: 'Arial, sans-serif' },
        automargin: true,
        tickangle: labels.length > 6 ? -45 : 0,
        fixedrange: true,
      },
      yaxis: {
        showgrid: true,
        gridcolor: '#f1f5f9',
        zeroline: true,
        zerolinecolor: '#e2e8f0',
        tickfont: { color: '#64748b', size: 10 },
        tickformat: 'd',
        dtick: maxAbsValue < 6 ? 1 : undefined,
        rangemode: 'tozero',
        fixedrange: true,
      },
      margin: { l: 25, r: 20, t: 20, b: 120 },
      paper_bgcolor: 'rgba(0,0,0,0)',
      plot_bgcolor: 'rgba(0,0,0,0)',
      hovermode: 'closest',
      bargap: gap,
    };

    this.graph.config = {
      ...DefaultConfig,
    };
  }
}
